export default __webpack_public_path__ + "static/media/nah.fb3bdff8.png";